module.exports = __webpack_public_path__ + "static/media/Angela_Ferrari_15.5e27afee.jpg";